export function InsuranceIcon() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0174 2.58401L20.0336 4.41699L20.0697 16.9471L12.0166 22.3973L3.9658 16.9487L3.92969 4.41657L12.0174 2.58401ZM5.43314 5.61393L5.46351 16.1511L12.0166 20.5861L18.5674 16.1526L18.537 5.61351L12.0158 4.12238L5.43314 5.61393ZM16.004 10.8087L11.0415 15.7712L8.01812 12.7478L9.07878 11.6871L11.0415 13.6499L14.9433 9.74808L16.004 10.8087Z"
        fill="#101010"
      />
    </svg>
  )
}
